import React,{useState,useEffect} from "react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, FormGroup, Label, Input} from "reactstrap";
import API from "../../../utils/API";
import {useHistory} from "react-router-dom";
import {toastr} from "react-redux-toastr";
import PublisherSelect from "../../../components/formfields/PublisherSelect";

const CopyFunctionality = ({rcid,copy,setCopy}) => {
    const [types,setTypes] = useState(null)
    const [settings, setSettings] = useState([])
    const [title, setTitle] = useState(null)
    const [selectedPublisher, setSelectedPublisher] = useState(null)
    let history = useHistory();

    const handleCheckboxChange = (e) => {
        let tempSettings = [...settings]
        if (!tempSettings.includes(e.target.value)) {
            tempSettings.push(e.target.value)
        }else {
            tempSettings = tempSettings.filter(item => item !== e.target.value)
        }

        setSettings(tempSettings)
    }

    const runCopy = () => {
        const params = {title: title}
        if (selectedPublisher && selectedPublisher.length > 0) {
            params.publisher_id = selectedPublisher[0]
        }
        API.post('/admin/copying/rcid/'+rcid.id,{types:settings,params:params}).then((response) => {
            toastr.success('Success', 'RCID copied successfully!')
            setCopy(false)
            history.push("/publisher/rcid/item/"+response.data.data)
        }).catch((error) => {
            console.error('Copy error:', error)
            toastr.error('Error', 'Failed to copy RCID')
        });
    }

    useEffect(()=>{
        if (copy && rcid) {
            API.get('/admin/copying/rcid').then((response) => {
                setTypes(response.data.data)
                setSettings(response.data.data)
            });
            
            // Set current publisher as default selection
            setSelectedPublisher([rcid.publisher.id]);
        }
    },[copy])

    return (<>
        {copy &&
            <Modal
                isOpen={copy}
                toggle={() => setCopy(false)}
                className="modal-dialog-centered"
                size="lg"
            >
                <ModalHeader toggle={() => setCopy(false)}>
                    Copy RCID: {rcid.title}
                </ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <Label for="title">New RCID Title</Label>
                        <Input
                            type="text"
                            name="title"
                            id="title"
                            placeholder="Enter new RCID title"
                            value={title || ''}
                            onChange={(e) => setTitle(e.target.value)}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="publisher">Publisher</Label>
                        <PublisherSelect
                            name="publisher"
                            value={selectedPublisher}
                            onChange={(name, value) => setSelectedPublisher(value)}
                            isMulti={false}
                            isClearable={false}
                        />
                    </FormGroup>
                    <div>
                        <Label>Select what to copy:</Label>
                        {types && types.map((type, index) => (
                            <FormGroup check key={index}>
                                <Label check>
                                    <Input
                                        type="checkbox"
                                        value={type}
                                        checked={settings.includes(type)}
                                        onChange={handleCheckboxChange}
                                    />
                                    {type}
                                </Label>
                            </FormGroup>
                        ))}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setCopy(false)}>
                        Cancel
                    </Button>
                    <Button color="primary" onClick={runCopy}>
                        Copy RCID
                    </Button>
                </ModalFooter>
            </Modal>
        }
    </>)
}

export default CopyFunctionality;
